import { __awaiter, __generator, __read } from "tslib";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { fetchAppGalleryConfig } from '@office-start/app-gallery-config-service';
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { queryCache } from '@office-start/data-fetching';
import { fetchFeatureGates } from '@office-start/feature-gates-service';
import { fetchIdentity } from '@office-start/identity-service';
import { executeWorkspacesDataFlow } from '../executeWorkspacesDataFlow';
export function fetchWorkspaces() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var _c, componentContext, identity, appGalleryConfig, featureGates, query;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        fetchOfficeComponentContext(),
                        fetchIdentity(),
                        fetchAppGalleryConfig(),
                        fetchFeatureGates(),
                    ])];
                case 1:
                    _c = __read.apply(void 0, [_d.sent(), 4]), componentContext = _c[0], identity = _c[1], appGalleryConfig = _c[2], featureGates = _c[3];
                    if ((identity === null || identity === void 0 ? void 0 : identity.isMsa) ||
                        ((_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.workspacesServiceBRSGates) === null || _b === void 0 ? void 0 : _b.workspacesServiceBRSEnabled))
                        return [2 /*return*/, Promise.resolve(undefined)];
                    query = ['WorkspacesData'];
                    return [2 /*return*/, queryCache.fetchQuery(query, function () {
                            return executeWorkspacesDataFlow(identity, componentContext, appGalleryConfig, function (freshData) { return queryCache.setQueryData(query, freshData); });
                        }, {
                            staleTime: Infinity,
                            cacheTime: Infinity,
                        })];
            }
        });
    });
}
//# sourceMappingURL=fetchWorkspaces.js.map